export enum TabStatusEnum {
  NOT_STARTED = '',
  IN_PROGRESS = 'in-progress-tab',
  COMPLETED = 'filled-tab',
}

export interface TabStatus {
  totalSections: number;
  completedSections: number;
}
